import { Grid } from '@mui/material';
import { getDashboardAllInstMeetingCountsApi, getDashboardMeetingCountInfoApi, getDashboardMeetingCountInfoByUnitsApi, getDashboardUserCountInfoApi, getParticipantDashboardInfoFromUserIdApi } from 'api/meeting';
import { isRoleCheckList } from 'app/utils/appHelpers';
import config from 'config';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import DashboardKurulOnlyDesign from 'app/components/Card/dashboardDesign/DashboardKurulOnlyDesign';
import DashboardSuperUserDesign from 'app/components/Card/dashboardDesign/DashboardSuperUserDesign';
import DashboardUyeOnlyDesign from 'app/components/Card/dashboardDesign/DashboardUyeOnlyDesign';
import DashboardYkAndKurulDesign from 'app/components/Card/dashboardDesign/DashboardYkAndKurulDesign';
import DashboardYkOnlyDesign from 'app/components/Card/dashboardDesign/DashboardYkOnlyDesign';
import DashboardYKUzmanDesign from 'app/components/Card/DashboardYKUzmanDesign';
import DashboardAnnouncementsCard from 'app/components/Card/DashboardAnnouncementsCard';
import LoadingPopUp from 'app/components/LoadingPopup';


function DashboardHomePage({ }) {
    //test cicd

    const { authUser } = useSelector(state => state.auth);
    const [loading, setLoading] = useState(false);
    const [countList, setCountList] = useState({});
    const [countUserInfo, setCountUserInfo] = useState({});

    const [ykCountList, setYKCountList] = useState({});
    const [kurulCard, setKurulCard] = useState(false);
    const [ykCard, setYkCard] = useState(false);
    const [uyeCard, setUyeCard] = useState(false);
    const [participantList, setParticipantList] = useState([]);
    const [superUserCard, setSuperUserCard] = useState(false);
    const [allInstMeetingCounts375, setAllInstMeetingCounts375] = useState([]);
    const [ykUzmanCard, setYkUzmanCard] = useState(false);
    const [announcementsCard, setAnnouncementsCard] = useState(false);

    const userRoles = authUser && authUser.userRoles;


    useEffect(() => {
        const getAPI = async () => {

            setLoading(true);
            try {

                const filteredInsts = config.institutions.filter(item => item.inst !== "YK").map(item => item.inst);
                const isSuperUser = isRoleCheckList(userRoles, [1]);
                const is375 = isRoleCheckList(userRoles, [375]);
                const is370 = isRoleCheckList(userRoles, [370]);
                const is372 = isRoleCheckList(userRoles, [372]);
                const is373 = isRoleCheckList(userRoles, [373]);
                const is369 = isRoleCheckList(userRoles, [369]);
                const is100 = isRoleCheckList(userRoles, [100]);
                const is373or369 = isRoleCheckList(userRoles, [373, 369]);

                // --- Hangi API'lerin çağrılacağını belirle (rol bazlı, senkron) ---
                const fetches = {
                    participant: getParticipantDashboardInfoFromUserIdApi(authUser.id),
                };

                if (is375) {
                    fetches.allInst375 = getDashboardAllInstMeetingCountsApi();
                }

                if (isSuperUser) {
                    setSuperUserCard(true);
                    // user-count endpoint'i byInstArray kullanmıyor; tek çağrı yeterli
                    fetches.userCount = getDashboardUserCountInfoApi(authUser.id, "all");
                    fetches.meetingKurul = getDashboardMeetingCountInfoApi(authUser.id, filteredInsts);
                    fetches.meetingYk = getDashboardMeetingCountInfoApi(authUser.id, "YK");
                } else if (is373or369) {
                    fetches.userCount = getDashboardUserCountInfoApi(authUser.id, filteredInsts);
                } else if (is370) {
                    fetches.userCount = getDashboardUserCountInfoApi(authUser.id, "YK");
                } else if (!is375) {
                    fetches.userCount = getDashboardUserCountInfoApi(authUser.id, "all");
                }

                if (!isSuperUser) {
                    if (is370) {
                        fetches.meetingYk = getDashboardMeetingCountInfoApi(authUser.id, "YK");
                        setYkCard(true);
                    }
                    if (is372) {
                        fetches.meetingYkByUnits = getDashboardMeetingCountInfoByUnitsApi(authUser.id, [370, 372]);
                        setYkCard(true);
                    }
                    if (is373) {
                        const insts = authUser.userRoles.filter(x => x.id === 373).map(x => x.inst);
                        fetches.meetingKurul = getDashboardMeetingCountInfoApi(authUser.id, insts);
                        setKurulCard(true);
                    }
                    if (is369) {
                        fetches.meetingKurulByUnits = getDashboardMeetingCountInfoByUnitsApi(authUser.id, [373, 369]);
                        setKurulCard(true);
                    }
                }

                if (!is375 && is100) {
                    setUyeCard(true);
                }

                // --- Tüm istekleri paralel çalıştır ---
                const keys = Object.keys(fetches);
                const values = await Promise.all(Object.values(fetches));
                const res = Object.fromEntries(keys.map((key, i) => [key, values[i]]));

                // --- Sonuçları uygula (sıralı, rol mantığı korunur) ---

                if (res.allInst375?.data !== undefined) {
                    setAllInstMeetingCounts375(res.allInst375.data);
                    setYkUzmanCard(true);
                }

                const userCount = res.userCount?.data?.[0];
                if (userCount !== undefined) {
                    setCountUserInfo({ ...userCount });

                    if (isSuperUser) {
                        setCountList({
                            ...(res.meetingKurul?.data?.[0] || {}),
                            userAdminMeetingCount: userCount.userAdminMeetingCount,
                        });
                        setYKCountList({
                            ...(res.meetingYk?.data?.[0] || {}),
                            userAdminMeetingCount: userCount.userAdminMeetingCount,
                        });
                    } else if (is373or369) {
                        setCountList(prevState => ({
                            ...prevState,
                            userAdminMeetingCount: userCount.userAdminMeetingCount,
                        }));
                    } else if (is370) {
                        setYKCountList(prevState => ({
                            ...prevState,
                            userAdminMeetingCount: userCount.userAdminMeetingCount,
                        }));
                    }
                }

                // Super user meeting count'ları yukarıda birleştirildi
                if (!isSuperUser) {
                    if (res.meetingYk?.data?.[0] !== undefined) {
                        setYKCountList(prevState => ({
                            ...res.meetingYk.data[0],
                            userAdminMeetingCount: prevState.userAdminMeetingCount ?? userCount?.userAdminMeetingCount,
                        }));
                    }
                    if (res.meetingYkByUnits?.data?.[0] !== undefined) {
                        setYKCountList(prevState => ({
                            ...res.meetingYkByUnits.data[0],
                            userAdminMeetingCount: prevState.userAdminMeetingCount ?? userCount?.userAdminMeetingCount,
                        }));
                    }
                    if (res.meetingKurul?.data?.[0] !== undefined) {
                        setCountList(prevState => ({
                            ...res.meetingKurul.data[0],
                            userAdminMeetingCount: prevState.userAdminMeetingCount ?? userCount?.userAdminMeetingCount,
                        }));
                    }
                    if (res.meetingKurulByUnits?.data?.[0] !== undefined) {
                        setCountList(prevState => ({
                            ...res.meetingKurulByUnits.data[0],
                            userAdminMeetingCount: prevState.userAdminMeetingCount ?? userCount?.userAdminMeetingCount,
                        }));
                    }
                }

                if (res.participant?.data !== undefined) {
                    setParticipantList(res.participant.data);
                }

                const hasOtherRoles = isRoleCheckList(userRoles, [373, 370, 369, 372]);
                const hasAnnouncementRoles = isRoleCheckList(userRoles, [416, 417]);
                if (!hasOtherRoles && hasAnnouncementRoles) {
                    setAnnouncementsCard(true);
                }

            } catch (error) {
                console.error('Hata:', error);
            } finally {
                setLoading(false);
            }
        };
        getAPI();

    }, []);


    return (
        <>
            <LoadingPopUp open={loading} />
            {!loading &&
                <Grid container spacing={1}>
                    {ykUzmanCard === true && (
                        <Grid item xs={12}>
                            <DashboardYKUzmanDesign instCounts={allInstMeetingCounts375} participantList={participantList} />
                        </Grid>
                    )}

                    {/* SuperUser Card */}
                    {superUserCard === true && (
                        <DashboardSuperUserDesign
                            userRoles={userRoles}
                            countUserInfo={countUserInfo}
                            countList={countList}
                            ykCountList={ykCountList}
                        />
                    )}

                    {/* YK ve Kurul Card */}
                    {(ykCard === true && kurulCard === true && uyeCard === false) && (
                        <DashboardYkAndKurulDesign
                            countList={countList}
                            countUserInfo={countUserInfo}
                            ykCountList={ykCountList}
                        />
                    )}

                    {/* Sadece Kurul Card */}
                    {(ykCard === false && kurulCard === true && uyeCard === false) && (
                        <DashboardKurulOnlyDesign
                            countList={countList}
                            countUserInfo={countUserInfo}
                            participantList={participantList}
                        />
                    )}

                    {/* Sadece YK Card */}
                    {(ykCard === true && kurulCard === false && uyeCard === false) && (
                        <DashboardYkOnlyDesign
                            countUserInfo={countUserInfo}
                            ykCountList={ykCountList}
                            participantList={participantList}
                        />
                    )}

                    {/* Sadece Üye Card */}
                    {superUserCard === false && uyeCard === true && (
                        <DashboardUyeOnlyDesign
                            countUserInfo={countUserInfo}
                        />
                    )}

                    {/* Duyurular Card */}
                    {announcementsCard === true && (
                        <Grid item xs={6}>
                            <DashboardAnnouncementsCard />
                        </Grid>
                    )}

                </Grid>
            }
        </>
    );
};

export default DashboardHomePage
